import axios from 'axios';
import config from './config.js';

class Api {
    constructor() {
        this.baseUrl = config.apiProtocol + '://' + config.apiUrl + '/';
        this.token = null;
        this.axiosConfig = {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        };

        this.getFileUrl = (key, name) => {
            return this.baseUrl + 'files/' + key + '/' + encodeURIComponent(name);
        }

        /** Pobiera plik z autoryzacją i uruchamia zapis na dysk (np. załącznik ticketu). */
        this.downloadFile = (fileKey, fileName, downloadName) => {
            const url = this.baseUrl + 'files/' + fileKey + '/' + encodeURIComponent(fileName);
            return axios.get(url, {
                responseType: 'blob',
                headers: { Authorization: this.axiosConfig.headers.Authorization }
            }).then(response => {
                const blob = response.data;
                const a = document.createElement('a');
                a.href = window.URL.createObjectURL(blob);
                a.download = downloadName || fileName || 'file';
                a.click();
                window.URL.revokeObjectURL(a.href);
            });
        }

        this.uploadFile = (file, progresCallback) => {
            // Nie ustawiać Content-Type – dla FormData axios sam doda multipart/form-data z boundary
            return axios.post(this.baseUrl + 'files', file, {
                headers: {
                    Authorization: this.axiosConfig.headers.Authorization
                },
                onUploadProgress: progresCallback
            })
                .then((response) => {
                    return response.data;
                })
                .catch(error => {
                    throw error.response;
                });
        }

        this.mailer = {
            template: {
                get: (code) => this.callCommonEndpoint(`mailer/templates/${code}`),
                save: (code, data) => this.callCommonEndpoint(`mailer/templates/${code}`, 'put', data)
            },
            history: {
                get: (query) => this.callCommonEndpoint('mailer/history', 'get', query)
            }
        }

        this.spreadsheet = {
            get: (id) => this.callCommonEndpoint('raports/spreadsheets/' + id, 'get'),
            search: (filters = {}) => this.callCommonEndpoint('raports/spreadsheets/search', 'post', filters),
            create: (data = {}) => this.callCommonEndpoint('raports/spreadsheets/', 'post', data),
            save: (id, data) => this.callCommonEndpoint('raports/spreadsheets/' + id, 'put', data)
        }

        this.aiAgent = {
            getAgents: () => this.callCommonEndpoint('raports/ai_agent/agents'),
            getChats: () => this.callCommonEndpoint('raports/ai_agent/chats'),
            getChat: (id) => this.callCommonEndpoint('raports/ai_agent/chats/' + id),
            deleteChat: (id) => this.callCommonEndpoint('raports/ai_agent/chats/' + id, 'delete'),
            /**
             * Wysyła wiadomość i streamuje odpowiedź (SSE). Bez chatId tworzy nowy chat.
             * onEvent(event, data) - zdarzenia: chat_created, text_delta, tool_start, tool_end,
             * tool_error, message, chat_title, error, done.
             */
            streamMessage: ({ chatId, content, agentSlug }, onEvent) => this.streamSSE(
                chatId ? `raports/ai_agent/chats/${chatId}/messages` : 'raports/ai_agent/chats',
                { content, agentSlug },
                onEvent
            ),
            files: {
                list: (chatId) => this.callCommonEndpoint(`raports/ai_agent/chats/${chatId}/files`),
                preview: (chatId, filename, maxChars) => this.callCommonEndpoint(
                    `raports/ai_agent/chats/${chatId}/files/${encodeURIComponent(filename)}/preview`,
                    'get',
                    maxChars ? { maxChars } : undefined
                ),
                remove: (chatId, filename) => this.callCommonEndpoint(
                    `raports/ai_agent/chats/${chatId}/files/${encodeURIComponent(filename)}`,
                    'delete'
                ),
                /** Pobiera plik workspace jako blob i zwraca obiekt URL (np. do podglądu w <img>) */
                blobUrl: (chatId, filename) => axios.get(
                    this.baseUrl + `raports/ai_agent/chats/${chatId}/files/${encodeURIComponent(filename)}`,
                    {
                        responseType: 'blob',
                        headers: { Authorization: this.axiosConfig.headers.Authorization }
                    }
                ).then(response => window.URL.createObjectURL(response.data)),
                /** Pobiera plik workspace z autoryzacją i uruchamia zapis na dysk */
                download: (chatId, filename) => axios.get(
                    this.baseUrl + `raports/ai_agent/chats/${chatId}/files/${encodeURIComponent(filename)}`,
                    {
                        responseType: 'blob',
                        headers: { Authorization: this.axiosConfig.headers.Authorization }
                    }
                ).then(response => {
                    const a = document.createElement('a');
                    a.href = window.URL.createObjectURL(response.data);
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(a.href);
                })
            },
            configs: {
                list: () => this.callCommonEndpoint('raports/ai_agent/configs'),
                create: (data) => this.callCommonEndpoint('raports/ai_agent/configs', 'post', data),
                update: (id, data) => this.callCommonEndpoint('raports/ai_agent/configs/' + id, 'put', data),
                remove: (id) => this.callCommonEndpoint('raports/ai_agent/configs/' + id, 'delete'),
                test: (id) => this.callCommonEndpoint('raports/ai_agent/configs/' + id + '/test', 'post')
            }
        }

        this.raports = {
            getProductsSummary: (agregacja, dateOne, dateTwo) => { return this.callCommonEndpoint('stats/productsSummary/' + agregacja + '/' + dateOne + '/' + dateTwo) },
            getYearlyProductionSummary: () => { return this.callCommonEndpoint('stats/yearlyProductionSummary') },
            getCurrenlyInProduction: () => { return this.callCommonEndpoint('stats/currenlyInProduction') },
            getTodaySummary: () => { return this.callCommonEndpoint('stats/todaySummary') },
            searchMadeProductsFromWorklogs: () => { return this.callCommonEndpoint('production/summary/work-day-summary-products') },
            searchMadeProductsFromWorklogsV3: () => { return this.callCommonEndpoint('production/summary/work-day-summary-products-v3') },
            getEmpMonthlyRaport: (data) => {
                let l = this.baseUrl + 'production/raports/empMonthlyRaport/?token=' + this.token;
                if (data.empId) l += '&empId=' + data.empId;
                if (typeof data.month != 'undefined') l += '&month=' + data.month;
                if (data.year) l += '&year=' + data.year;
                return l;
            },
            getworkingTimeReportMonthlyRaport: (data) => {
                let l = this.baseUrl + 'employee-raports/workingTimeReport/?token=' + this.token;
                if (typeof data.month != 'undefined') l += '&month=' + data.month;
                if (data.year) l += '&year=' + data.year;
                return l;
            },

            generateWorkingTimeReportMonthlyRaport: (data) => { return this.downloadAsBlob('employee-raports/workingTimeReport', 'post', data); },
            generateSummaryEmployeesMonthlyRaport: (data) => { return this.downloadAsBlob('employee-raports/summaryEmployeesMonthlyRaport', 'post', data); },
            getnerateFreeDaysMonthlyRaport: (data) => { return this.downloadAsBlob('employee-raports/generateFreeDaysMonthlyRaport', 'post', data); },

            getSummaryEmployeesMonthlyRaport: (data) => {
                let l = this.baseUrl + 'employee-raports/summaryEmployeesMonthlyRaport/?token=' + this.token;
                if (typeof data.month != 'undefined') l += '&month=' + data.month;
                if (data.year) l += '&year=' + data.year;
                return l;
            },
            getPalletAndBoxesRaport: (data) => {
                let l = this.baseUrl + 'stats/raport.csv?token=' + this.token;
                if (data.dateFrom) l += '&dateFrom=' + data.dateFrom;
                if (data.dateTo) l += '&dateTo=' + data.dateTo;
                return l;
            },
            getZPTimeRealizationRaport: (data) => {
                let l = this.baseUrl + 'production/raports/ZPTimeRealization.csv?token=' + this.token;
                if (data.dateFrom) l += '&dateFrom=' + data.dateFrom;
                if (data.dateTo) l += '&dateTo=' + data.dateTo;
                if (data.compareTo) l += '&compareTo=' + data.compareTo;
                return l;
            }
        }

        this.printing = {
            prepare: (templateId, data) => { return this.callCommonEndpoint('production/print/prepare', 'post', { templateId, data }) },
            getPreparedPrintUrl: (printKey) => { return this.baseUrl + 'production/print/prepared/' + printKey + '?token=' + this.token; },
            templates: {
                search: (data) => { return this.callCommonEndpoint('production/print/template/search', 'post', data) },
                get: (tplId) => { return this.callCommonEndpoint('production/print/template/' + tplId) },
                edit: (tplId, data) => { return this.callCommonEndpoint('production/print/template/' + tplId, 'put', data) },
                create: (data) => { return this.callCommonEndpoint('production/print/template', 'post', data) },
                seveOrderTemplates: (orderId, data) => { return this.callCommonEndpoint('orders/' + orderId + '/printTemplate', 'put', data) }
            }
        }

        this.summary = {
            getCompletedProductTypesPerDay: (data) => { return this.callCommonEndpoint('production/summary/completedProductTypesPerDay_agregation', 'post', data) },
            getCompletedPRsProductTypePerEmployee: (data) => { return this.callCommonEndpoint('production/summary/completedPRsProductTypePerEmployee_agregation', 'post', data) },
            completedProductTypesForEmployee: (data) => { return this.callCommonEndpoint('production/summary/completedProductTypesForEmployee_agregation', 'post', data) },
            productionTimePerProductType: (data) => { return this.callCommonEndpoint('production/summary/productionTimePerProductType_agregation', 'post', data) },
            getProductionProductTypesV3: (data) => { return this.callCommonEndpoint('production/summary/productionProductTypes_agregation', 'post', data) },
            getProductionProductTypes: (data) => { return this.callCommonEndpoint('production/summary/production-product-types', 'post', data) },
            getCompletedTasksPerDay: (data) => { return this.callCommonEndpoint('production/summary/completedTasksPerDay', 'post', data) },
            getCompletedTasksPerEmployee: (data) => { return this.callCommonEndpoint('production/summary/completedTasksPerEmployee', 'post', data) },
            completedTasksForEmployee: (data) => { return this.callCommonEndpoint('production/summary/completedTasksForEmployee', 'post', data) },
            productionTimePerTask: (data) => { return this.callCommonEndpoint('production/summary/productionTimePerTask', 'post', data) }

            // statystyki po orderze
            // getProductionForProductTypes: (data) => { return this.callCommonEndpoint('stats/productionProductTypes', 'post', data) }
        }

        this.device = {
            search: (data) => { return this.callCommonEndpointWithTotal('devices/search', 'post', data) },
            getAll: () => { return this.callCommonEndpoint('devices/all') },
            edit: (deviceId, data) => { return this.callCommonEndpoint('devices/' + deviceId, 'put', data) }
        }

        this.user = {
            verifyUser: (token) => this.callCommonEndpoint('auth/verify.v2', 'post', { token }),
            logIn: (email, pass) => { return this.callCommonEndpoint('auth/signin', 'post', { user: email, pass: pass }) },
            logOut: () => { return this.callCommonEndpoint('auth/signout', 'post', {}) },

            resetPassword: (email) => { return this.callCommonEndpoint('users/reset-password', 'post', { email: email }) },
            resetPasswordConfirm: (code) => { return this.callCommonEndpoint('users/reset-password-confirm', 'post', { code: code }) },
            get: () => { return this.callCommonEndpoint('users/all') },
            getOne: (id) => { return this.callCommonEndpoint('users/' + id) },
            getUsersHisory: (filters) => { return this.callCommonEndpointWithTotal('users/history/search', 'post', filters) },
            getUserLoginRaport: (data) => { return this.callCommonEndpoint('users/login-history', 'post', data) },

            register: (emp) => { return this.callCommonEndpoint('users/register', 'post', { email: emp.email, name: emp.name, password: emp.password, roles: emp.roles }) },
            remove: (id) => { return this.callCommonEndpoint('users/' + id, 'put', { isRemoved: true }) },
            edit: (emp) => { return this.callCommonEndpoint('users/' + emp._id, 'put', emp) },
            putInStorage: (key, value) => { return this.callCommonEndpoint('storage/', 'post', { key: key, value: value }) },
            getFromStorage: (key) => { return this.callCommonEndpoint('storage/' + key) },
            getNotifications: () => { return this.callCommonEndpoint('notifications/not-seen') },
            setNotificationAsSeen: (notifId) => { return this.callCommonEndpoint('notifications/setSeen/' + notifId, 'post') },
            setManyNotificationsAsSeen: (where) => { return this.callCommonEndpoint('notifications/setSeenMany', 'post', where) },
            signatures: {
                list: (userId) => this.callCommonEndpoint(userId ? 'users/' + userId + '/signatures' : 'users/me/signatures'),
                create: (data, userId) => this.callCommonEndpoint(userId ? 'users/' + userId + '/signatures' : 'users/me/signatures', 'post', data),
                update: (id, data, userId) => this.callCommonEndpoint(userId ? 'users/' + userId + '/signatures/' + id : 'users/me/signatures/' + id, 'put', data),
                remove: (id, userId) => this.callCommonEndpoint(userId ? 'users/' + userId + '/signatures/' + id : 'users/me/signatures/' + id, 'delete')
            },
            signatureAssignments: {
                get: (userId) => this.callCommonEndpoint(userId ? 'users/' + userId + '/signature-assignments' : 'users/me/signature-assignments'),
                update: (data, userId) => this.callCommonEndpoint(userId ? 'users/' + userId + '/signature-assignments' : 'users/me/signature-assignments', 'put', data)
            },
            vacation: (data) => this.callCommonEndpoint('users/me/vacation', 'put', data)
        }

        this.forms = {
            getOne: (id) => this.callCommonEndpoint('forms/' + id),
            get: (query) => this.callCommonEndpointWithTotal('forms/', 'get', { q: query }),
            summary: (formId) => this.callCommonEndpoint('forms/summary/' + formId, 'get'),
            create: (title) => this.callCommonEndpoint('forms/', 'post', { name: title }),
            save: (formId, data) => this.callCommonEndpoint('forms/' + formId, 'put', data)
        }

        this.emp = {
            get: (id) => { return this.callCommonEndpoint('employees/' + id) },
            getEmployees: () => this.callCommonEndpoint('employees/all', 'get', { includeRemoved: true }),
            searchWithTotal: (filters) => this.callCommonEndpointWithTotal('employees/search', 'post', filters),
            register: (emp) => { return this.callCommonEndpoint('employees/register', 'post', { name: emp.name, pin: emp.pin, workPlaces: emp.workPlaces, workingHours: { from: emp.workingHours.from, to: emp.workingHours.to } }) },
            remove: (id) => { return this.callCommonEndpoint('employees/' + id, 'put', { isRemoved: true }) },
            edit: (emp) => { return this.callCommonEndpoint('employees/' + emp._id, 'put', emp) },
            update: (id, data) => { return this.callCommonEndpoint('employees/' + id, 'put', data) },
            getLoggedEmployeesAtDevice: (deviceId) => this.callCommonEndpoint('production/employee/getLoggedEmployeesAtDevice/' + deviceId),

            getWorkingStats: (empId, since) => { return this.callCommonEndpoint(`production/employee/${empId}/production-stats-since/${since}`) },
            getDayActivity: (empId, day) => { return this.callCommonEndpoint(`production/employee/${empId}/working-ranges-for-day/${day}`) },

            getAplicationsRapots: (data) => {
                let l = this.baseUrl + 'employee-raports/getApplicationFreeDaysRaport/?token=' + this.token;
                if (data.empId) l += '&empId=' + data.empId;
                if (typeof data.from != 'undefined') l += '&from=' + data.from;
                if (data.to) l += '&to=' + data.to;
                return l;
            },
            getAplicationsFreeDaysForEmpRapots: (data) => {
                let l = this.baseUrl + 'employee-raports/getApplicationFreeDaysV3Raport/?token=' + this.token;
                if (data.empId) l += '&empId=' + data.empId;
                if (typeof data.from != 'undefined') l += '&from=' + data.from;
                if (data.to) l += '&to=' + data.to;
                return l;
            },
            getFreeDaysMonthlyRaport: (data) => {
                let l = this.baseUrl + 'employee-raports/getFreeDaysMonthlyRaport/?token=' + this.token;
                if (typeof data.month != 'undefined') l += '&month=' + data.month;
                if (data.year) l += '&year=' + data.year;
                return l;
            }
        }

        this.timer = {
            search: (data) => { return this.callCommonEndpoint('employee-timer/search', 'post', data) },
            getEmployeeTimer: (employeeId) => { return this.callCommonEndpoint('employee-timer/' + employeeId) },
            createTimer: (id) => { return this.callCommonEndpoint('employee-timer/', 'post', { employeeId: id }) },
            coffeBreakStart: (id) => { return this.callCommonEndpoint('employee-timer/coffe-break-start', 'put', { employeeId: id }) },
            coffeBreakEnd: (id) => { return this.callCommonEndpoint('employee-timer/coffe-break-end', 'put', { employeeId: id }) },
            stopTimer: (id) => { return this.callCommonEndpoint('employee-timer/stop-timer', 'put', { employeeId: id }) }
        }

        this.order = {
            getOrders: (filters) => this.callCommonEndpointWithTotal('orders/search', 'post', filters),
            search: (data) => { return this.callCommonEndpoint('orders/search', 'post', data) },
            searchByCustomer: (customerId, options) => {
                const q = 'customer=' + encodeURIComponent(customerId);
                return this.callCommonEndpoint('orders/search?' + q, 'post', options || {});
            },
            getOrder: (id) => { return this.callCommonEndpoint('orders/' + id) },

            documentRepository: (id) => { return this.callCommonEndpoint('orders/' + id + '/document-repository') },
            addDocument: (id, data) => { return this.callCommonEndpoint('orders/' + id + '/documents', 'post', data) },
            removeDocument: (id, docId) => { return this.callCommonEndpoint('orders/' + id + '/documents/' + docId, 'delete') },

            clone: (id) => this.callCommonEndpoint('orders/clone/' + id, 'post', {}),

            getConfig: () => { return this.callCommonEndpoint('orders/configuration') },
            setConfig: (conf) => { return this.callCommonEndpoint('orders/configuration', 'post', conf) },

            remove: (id) => { return this.callCommonEndpoint('orders/' + id, 'delete') },
            setTags: (id, tags) => { return this.callCommonEndpoint('orders/' + id, 'put', { tags }) },
            add: () => { return this.callCommonEndpoint('orders/', 'post') },
            addNote: (id, data) => { return this.callCommonEndpoint('orders/' + id + '/notes', 'post', data) },
            removeNote: (id, idNote) => { return this.callCommonEndpoint('orders/' + id + '/notes/' + idNote, 'delete') },
            attachFile: (id, key, name) => { return this.callCommonEndpoint('orders/' + id + '/attachments', 'post', { key: key, name: name }) },
            removeAttachment: (id, idAttach) => { return this.callCommonEndpoint('orders/' + id + '/attachments/' + idAttach, 'delete') },
            addProduct: (id, data) => { return this.callCommonEndpoint('orders/' + id + '/cart', 'post', data) },
            removeProduct: (id, idPosition) => { return this.callCommonEndpoint('orders/' + id + '/cart/' + idPosition, 'delete') },
            editCarPos: (id, idPosition, data) => { return this.callCommonEndpoint('orders/' + id + '/cart/' + idPosition, 'put', data) },
            massEditCart: (id, data) => { return this.callCommonEndpoint('orders/' + id + '/cart/mass-edit/', 'put', data) },
            editCarPosSerialNumbers: (id, idPosition, data) => { return this.callCommonEndpoint('orders/' + id + '/cart/' + idPosition + '/serial-numbers', 'put', data) },
            addCartGroup: (id, data) => { return this.callCommonEndpoint('orders/' + id + '/groups', 'post', data) },
            editCartGroup: (id, groupId, data) => { return this.callCommonEndpoint('orders/' + id + '/groups/' + groupId, 'put', data) },
            removeCartGroup: (id, groupId) => { return this.callCommonEndpoint('orders/' + id + '/groups/' + groupId, 'delete') },
            setCustomer: (id, idCustomer) => { return this.callCommonEndpoint('orders/' + id, 'put', { customer: idCustomer }) },
            setDeliverAddress: (id, addressId) => { return this.callCommonEndpoint('orders/' + id, 'put', { deliveryAddressId: addressId }) },
            setName: (id, name) => { return this.callCommonEndpoint('orders/' + id, 'put', { name: name }) },
            setStatus: (id, status) => { return this.callCommonEndpoint('orders/' + id, 'put', { status: status }) },
            save: (id, data) => { return this.callCommonEndpoint('orders/' + id, 'put', data) },
            massConfirm: () => { return this.callCommonEndpoint('orders/mass-confirm', 'post', {}) },

            recalculateProgress: (id) => { return this.callCommonEndpoint('orders/' + id + '/recalculateProgress', 'post', {}) },
            getAvailableTags: () => { return this.callCommonEndpoint('orders/availableTags') },

            addBox: (orderId) => { return this.callCommonEndpoint('orders/' + orderId + '/box/', 'post', {}) },
            removeBox: (orderId, boxCode) => { return this.callCommonEndpoint('orders/' + orderId + '/box/' + boxCode, 'delete', {}) },
            editBox: (id, boxCode, data) => { return this.callCommonEndpoint('orders/' + id + '/box/' + boxCode, 'put', data) },
            editPalette: (id, paletteId, data) => { return this.callCommonEndpoint('orders/' + id + '/paletes/' + paletteId, 'put', data) },

            packingSuggest: (data) => { return this.callCommonEndpoint('orders_module/packing/suggest', 'post', data) }
        }

        this.cart = {
            completePos: (cartItemId) => { return this.callCommonEndpoint('production/tasks/complete/byCartItemId/' + cartItemId, 'post', {}) },
            changeStatusPos: (cartItemId, data) => { return this.callCommonEndpoint('production/tasks/changeStatus/byCartItemId/' + cartItemId, 'post', data) }
        }

        this.wFirma = {
            getByOrderId: (id) => { return this.callCommonEndpoint('wfirma/invoices/byOrderId/' + id) },
            getFileUrl: (id) => { return this.baseUrl + 'wfirma/invoices/print/' + id + '?token=' + this.token; },
            set: (data) => { return this.callCommonEndpoint('wfirma/configuration', 'put', data) },
            get: () => { return this.callCommonEndpoint('wfirma/configuration') },
            getGoodByProduct: (id) => { return this.callCommonEndpoint('wfirma/goods/byProductId/' + id) },
            searchStockOrders: () => { return this.callCommonEndpoint('wfirma/stock-orders/search', 'post', {}) },
            importStockOrder: (stockOrderId) => { return this.callCommonEndpoint('wfirma/stock-orders/import/' + stockOrderId, 'post', {}) },
            warehouseDocuments: {
                getByPR: (prId) => { return this.callCommonEndpoint('wfirma/stock-docs/byPR/' + prId) },
                getByOrderId: (orderId) => { return this.callCommonEndpoint('wfirma/stock-docs/byOrderId/' + orderId) },
                getByStockEvent: (stockEventId) => { return this.callCommonEndpoint('wfirma/stock-docs/byStockEvent/' + stockEventId) }
            },
            offers: {
                search: (name) => this.callCommonEndpoint('wfirma/offers/search', 'get', { name }),
                get: (offerId) => this.callCommonEndpoint(`wfirma/offers/${offerId}`),
                pdfUrl: (offerId) => this.baseUrl + 'wfirma/offers/' + offerId + '/pdf?token=' + this.token,
                uploadToFiles: (offerId) => this.callCommonEndpoint(`wfirma/offers/${offerId}/upload-to-files`, 'post')
            },
            proformas: {
                search: (name) => this.callCommonEndpoint('wfirma/offers/proformas/search', 'get', { name }),
                pdfUrl: (id) => this.baseUrl + 'wfirma/offers/proformas/' + id + '/pdf?token=' + this.token,
                uploadToFiles: (id) => this.callCommonEndpoint(`wfirma/offers/proformas/${id}/upload-to-files`, 'post')
            },
            invoices: {
                /**
                 * Wyszukuje faktury w wFirma na podstawie listy filtrów (POST wfirma/invoices/search).
                 *
                 * @param {Array<{field: string, operator: string, value: *}>} [filters=[]] - Lista filtrów. Każdy filtr musi być obiektem
                 *        zawierającym pola `field`, `operator` oraz `value`. Backend waliduje strukturę i zwraca błąd
                 *        `{ code: "invalid-filters" }` (HTTP 400), jeśli którykolwiek element nie spełnia tego kontraktu.
                 * @param {number} [limit=10] - Liczba wyników na stronę. Backend przycina wartość do maksymalnie 100
                 *        (domyślnie 50, jeśli nie zostanie podana).
                 * @param {number} [page=1] - Numer strony (1-indeksowany). Backend wymusza wartość minimalną równą 1.
                 * @returns {Promise<{items: Array<Object>, total: number, page: number, limit: number}>} Obiekt z wynikami:
                 *        `items` - tablica znalezionych faktur, `total` - łączna liczba pasujących faktur,
                 *        `page` - zwrócona strona, `limit` - zastosowany limit na stronę.
                 */
                search: (filters = [], limit = 10, page = 1) => this.callCommonEndpoint('wfirma/invoices/search', 'post', { filters, limit, page }),
                get: (invoiceId) => this.callCommonEndpoint(`wfirma/invoices/${invoiceId}`)
            }

        }

        this.customer = {
            get: (id) => { return this.callCommonEndpoint('customers/' + id) },
            getCustomers: (query) => { return this.callCommonEndpoint('customers/search', 'post', { query: query }) },
            edit: (id, data) => { return this.callCommonEndpoint('customers/' + id, 'put', data) },
            add: (data) => { return this.callCommonEndpoint('customers/', 'post', data) },
            search: (filters) => this.callCommonEndpointWithTotal('customers/search', 'post', filters),
            merge: (targetId, sourceCustomerId) => { return this.callCommonEndpoint('customers/' + targetId + '/merge', 'post', { sourceCustomerId }) }
        }

        this.crm = {
            offers: {
                get: (offerId) => this.callCommonEndpoint(`crm/offers/${offerId}`),
                search: (filters) => this.callCommonEndpoint('crm/offers', 'get', filters),
                create: (data) => this.callCommonEndpoint('crm/offers', 'post', data),
                update: (offerId, data) => this.callCommonEndpoint(`crm/offers/${offerId}`, 'put', data),
                remove: (offerId) => this.callCommonEndpoint(`crm/offers/${offerId}`, 'delete'),

                setStatus: (offerId, data) => this.callCommonEndpoint(`crm/offers/${offerId}/status`, 'put', data),
                setStage: (offerId, data) => this.callCommonEndpoint(`crm/offers/${offerId}/stage`, 'put', data),
                completeTask: (offerId, taskId, data) => this.callCommonEndpoint(`crm/offers/${offerId}/tasks/${taskId}/completion`, 'put', data),
                addEvent: (offerId, data) => this.callCommonEndpoint(`crm/offers/${offerId}/events`, 'post', data)
            },

            saleStages: {
                get: (stageId) => this.callCommonEndpoint(`crm/sale-stages/${stageId}`),
                search: (filters) => this.callCommonEndpoint('crm/sale-stages', 'get', filters),
                create: (data) => this.callCommonEndpoint('crm/sale-stages', 'post', data),
                update: (stageId, data) => this.callCommonEndpoint(`crm/sale-stages/${stageId}`, 'put', data),
                remove: (stageId) => this.callCommonEndpoint(`crm/sale-stages/${stageId}`, 'delete')
            },

            tasks: {
                get: (taskId) => this.callCommonEndpoint(`crm/tasks/${taskId}`),
                search: (filters) => this.callCommonEndpoint('crm/tasks', 'get', filters),
                create: (data) => this.callCommonEndpoint('crm/tasks', 'post', data),
                update: (taskId, data) => this.callCommonEndpoint(`crm/tasks/${taskId}`, 'put', data),
                remove: (taskId) => this.callCommonEndpoint(`crm/tasks/${taskId}`, 'delete')
            },

            stats: {
                overview: (filters) => this.callCommonEndpoint('crm/stats/overview', 'get', filters),
                pipeline: (filters) => this.callCommonEndpoint('crm/stats/pipeline', 'get', filters),
                users: (filters) => this.callCommonEndpoint('crm/stats/users', 'get', filters)
            }
        }

        this.imap = {
            config: {
                list: () => this.callCommonEndpoint('imap/config', 'get'),
                get: (id) => this.callCommonEndpoint(`imap/config/${id}`),
                create: (data) => this.callCommonEndpoint('imap/config', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`imap/config/${id}`, 'put', data),
                remove: (id) => this.callCommonEndpoint(`imap/config/${id}`, 'delete'),
                test: (id) => this.callCommonEndpoint(`imap/config/${id}/test`, 'post'),
                autodetect: (data) => this.callCommonEndpoint('imap/config/autodetect', 'post', data)
            },
            messages: {
                search: (filters) => this.callCommonEndpoint('imap/messages', 'get', filters),
                get: (id) => this.callCommonEndpoint(`imap/messages/${id}`),
                unreadCount: () => this.callCommonEndpoint('imap/messages/unread-count'),
                complete: (id, data) => this.callCommonEndpoint(`imap/messages/${id}/complete`, 'put', data),
                assignOffer: (id, data) => this.callCommonEndpoint(`imap/messages/${id}/assign-offer`, 'put', data),
                reply: (data) => this.callCommonEndpoint('imap/messages/reply', 'post', data)
            },
            tickets: {
                list: (filters) => this.callCommonEndpoint('imap/tickets', 'get', filters),
                create: (data) => this.callCommonEndpoint('imap/tickets', 'post', data),
                get: (id) => this.callCommonEndpoint(`imap/tickets/${id}`),
                update: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}`, 'put', data),
                linkCustomer: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/link-customer`, 'put', data),
                linkTicket: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/link-ticket`, 'post', data),
                unlinkTicket: (id, targetId) => this.callCommonEndpoint(`imap/tickets/${id}/link-ticket/${targetId}`, 'delete'),
                searchOrders: (query) => this.callCommonEndpoint('imap/tickets/orders/search', 'get', { query }),
                linkOrder: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/link-order`, 'post', data),
                unlinkOrder: (id, orderId) => this.callCommonEndpoint(`imap/tickets/${id}/link-order/${orderId}`, 'delete'),
                byOrder: (orderId) => this.callCommonEndpoint(`imap/tickets/by-order/${orderId}`, 'get'),
                addRelation: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/relations`, 'post', data),
                removeRelation: (id, relationId) => this.callCommonEndpoint(`imap/tickets/${id}/relations/${relationId}`, 'delete'),
                byRelation: (code, refId) => this.callCommonEndpoint(`imap/tickets/by-relation/${code}/${refId}`, 'get'),
                byRelationBulk: (code, refIds) => this.callCommonEndpoint(`imap/tickets/by-relation/${code}`, 'get', { refIds: (refIds || []).join(',') }),
                attachments: (id) => this.callCommonEndpoint(`imap/tickets/${id}/attachments`, 'get'),
                setAttachmentMeta: (id, messageId, data) => this.callCommonEndpoint(`imap/tickets/${id}/messages/${messageId}/attachments`, 'put', data),
                markRead: (id) => this.callCommonEndpoint(`imap/tickets/${id}/read`, 'put'),
                messages: (id) => this.callCommonEndpoint(`imap/tickets/${id}/messages`),
                replyCcInNewTicket: (id, messageId, email) => this.callCommonEndpoint(`imap/tickets/${id}/messages/${messageId}/reply-cc`, 'post', { email }),
                updateRecipients: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/recipients`, 'put', data),
                reply: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/reply`, 'post', data),
                saveReplyDraft: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/reply-draft`, 'put', data),
                deleteReplyDraft: (id) => this.callCommonEndpoint(`imap/tickets/${id}/reply-draft`, 'delete'),
                publish: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/publish`, 'post', data),
                addNote: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/note`, 'post', data),
                setNoteImportant: (id, messageId, isImportant) => this.callCommonEndpoint(`imap/tickets/${id}/messages/${messageId}/important`, 'put', { isImportant }),
                stats: () => this.callCommonEndpoint('imap/tickets/stats'),
                setCategory: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/category`, 'put', data),
                setStage: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/stage`, 'put', data),
                updateChecklist: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/checklist`, 'put', data),
                addChecklistItem: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/checklist/add`, 'post', data),
                assignees: (params) => this.callCommonEndpoint('imap/tickets/assignees', 'get', params),
                checkWFirmaOffer: (id, wFirmaId) => this.callCommonEndpoint(`imap/tickets/${id}/wfirma-offers/${wFirmaId}/check`, 'post', {}),
                scheduledTasks: (params) => this.callCommonEndpoint('imap/tickets/scheduled-tasks', 'get', params),
                createTask: (data) => this.callCommonEndpoint('imap/tickets/tasks', 'post', data),
                updateTask: (taskId, data) => this.callCommonEndpoint(`imap/tickets/tasks/${taskId}`, 'put', data),
                toggleTask: (taskId, completed) => this.callCommonEndpoint(`imap/tickets/tasks/${taskId}/toggle`, 'put', { completed }),
                deleteTask: (taskId) => this.callCommonEndpoint(`imap/tickets/tasks/${taskId}`, 'delete'),
                bulkSetStatus: (ids, status) => this.callCommonEndpoint('imap/tickets/bulk-status', 'put', { ids, status }),
                bulkMoveToTrash: (ids) => this.callCommonEndpoint('imap/tickets/bulk-trash', 'put', { ids }),
                bulkMoveToTrashByEmails: (emails) => this.callCommonEndpoint('imap/tickets/bulk-trash-by-emails', 'put', { emails }),
                bulkRestore: (ids, removeFromBlacklistEmails = []) => this.callCommonEndpoint('imap/tickets/bulk-restore', 'put', { ids, removeFromBlacklistEmails }),
                bulkPermanentDelete: (ids) => this.callCommonEndpoint('imap/tickets/bulk-permanent', 'delete', { ids }),
                bulkPermanentDeleteTrash: (ids) => this.callCommonEndpoint('imap/tickets/bulk-permanent-trash', 'delete', { ids }),
                moveMessage: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/move-message`, 'post', data),
                generateReplyDraft: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/ai-reply-draft`, 'post', data),
                generateGuidance: (id) => this.callCommonEndpoint(`imap/tickets/${id}/ai-guidance`, 'post', {}),
                executeAiAction: (id, actionIndex) => this.callCommonEndpoint(`imap/tickets/${id}/ai-action/${actionIndex}`, 'post', {}),
                kanban: (filters) => this.callCommonEndpoint('imap/tickets/kanban', 'get', filters),
                statsOverview: (filters) => this.callCommonEndpoint('imap/tickets/stats/overview', 'get', filters),
                statsPerUser: (filters) => this.callCommonEndpoint('imap/tickets/stats/per-user', 'get', filters),
                statsPerCategory: (filters) => this.callCommonEndpoint('imap/tickets/stats/per-category', 'get', filters),
                statsByCategory: (filters) => this.callCommonEndpoint('imap/tickets/stats/by-category', 'get', filters),
                createRfq: (data) => this.callCommonEndpoint('imap/tickets/rfq', 'post', data),
                rfqReply: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/rfq-reply`, 'post', data),
                setSupplierVisibility: (id, data) => this.callCommonEndpoint(`imap/tickets/${id}/supplier-visibility`, 'put', data),
                fifoCheck: () => this.callCommonEndpoint('imap/tickets/fifo-check', 'get')
            },
            senderBlacklist: {
                list: () => this.callCommonEndpoint('imap/sender-blacklist', 'get'),
                add: (email, reason = '') => this.callCommonEndpoint('imap/sender-blacklist', 'post', { email, reason }),
                bulkAdd: (emails, reason = '') => this.callCommonEndpoint('imap/sender-blacklist/bulk-add', 'post', { emails, reason }),
                bulkRemove: (emails) => this.callCommonEndpoint('imap/sender-blacklist/bulk-remove', 'post', { emails }),
                remove: (id) => this.callCommonEndpoint(`imap/sender-blacklist/${id}`, 'delete')
            },
            categories: {
                list: () => this.callCommonEndpoint('imap/categories'),
                get: (id) => this.callCommonEndpoint(`imap/categories/${id}`),
                create: (data) => this.callCommonEndpoint('imap/categories', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`imap/categories/${id}`, 'put', data),
                remove: (id) => this.callCommonEndpoint(`imap/categories/${id}`, 'delete')
            },
            stages: {
                list: (filters) => this.callCommonEndpoint('imap/stages', 'get', filters),
                get: (id) => this.callCommonEndpoint(`imap/stages/${id}`),
                create: (data) => this.callCommonEndpoint('imap/stages', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`imap/stages/${id}`, 'put', data),
                remove: (id) => this.callCommonEndpoint(`imap/stages/${id}`, 'delete')
            },
            openrouter: {
                get: () => this.callCommonEndpoint('imap/settings/openrouter'),
                update: (data) => this.callCommonEndpoint('imap/settings/openrouter', 'put', data),
                models: (filters) => this.callCommonEndpoint('imap/settings/openrouter/models', 'get', filters),
                test: (data) => this.callCommonEndpoint('imap/settings/openrouter/test', 'post', data)
            },
            fifo: {
                get: () => this.callCommonEndpoint('imap/settings/fifo'),
                update: (data) => this.callCommonEndpoint('imap/settings/fifo', 'put', data)
            },
            autoReplyTemplates: {
                list: (filters) => this.callCommonEndpoint('imap/auto-reply-templates', 'get', filters),
                get: (id) => this.callCommonEndpoint(`imap/auto-reply-templates/${id}`),
                create: (data) => this.callCommonEndpoint('imap/auto-reply-templates', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`imap/auto-reply-templates/${id}`, 'put', data),
                reorder: (items) => this.callCommonEndpoint('imap/auto-reply-templates/reorder', 'put', { items }),
                remove: (id) => this.callCommonEndpoint(`imap/auto-reply-templates/${id}`, 'delete')
            }
        }

        this.shipments = {
            readShipmentLabel: (data) => {
                return this.callCommonEndpoint('shipments/read-shipment-label', 'post', data)
            },
            getRaportCsvLink: (data) => {
                let l = this.baseUrl + 'shipments/stats/raport.csv?token=' + this.token;
                if (data.dateFrom) l += '&dateFrom=' + data.dateFrom;
                if (data.dateTo) l += '&dateTo=' + data.dateTo;
                if (data.agregation) l += '&agregation=' + data.agregation;
                return l;
            },
            add: (data) => { return this.callCommonEndpoint('shipments/', 'post', data) },
            getPriceRanges: () => this.callCommonEndpoint('shipments/price-ranges'),
            getCofiguration: () => { return this.callCommonEndpoint('shipments/configuration') },
            set: (data) => { return this.callCommonEndpoint('shipments/configuration', 'post', data) },
            sendEmailNotif: (shipmentIds) => { return this.callCommonEndpoint('shipments/notifyByEmail', 'post', { shipments: shipmentIds }) },
            handedOverByUser: (shipmentIds) => { return this.callCommonEndpoint('shipments/handedOverByUser', 'post', { shipments: shipmentIds }) },
            ppSent: (data) => { return this.callCommonEndpoint('shipments/poczta-polska/send', 'post', data) },
            ppSendEnvelope: () => { return this.callCommonEndpoint('shipments/poczta-polska/send-envelope') },
            dpdSent: (data) => { return this.callCommonEndpoint('shipments/dpd/send', 'post', data) },
            suusSent: (data) => { return this.callCommonEndpoint('shipments/suus/send', 'post', data) },
            suusVerify: () => { return this.callCommonEndpoint('shipments/suus/verify', 'post', ) },
            rhenusSent: (data) => { return this.callCommonEndpoint('shipments/rhenus/send', 'post', data) },
            geisSent: (data) => { return this.callCommonEndpoint('shipments/geis/send', 'post', data) },
            geisCreatePickUp: (data) => { return this.callCommonEndpoint('shipments/geis/create-pickup', 'post', data) },
            fedexSent: (data) => { return this.callCommonEndpoint('shipments/fedex/send', 'post', data) },
            dhlSent: (data) => { return this.callCommonEndpoint('shipments/dhl/send', 'post', data) },

            marssSent: (data) => { return this.callCommonEndpoint('shipments/marss/send', 'post', data) },

            inpost: {
                verify: () => this.callCommonEndpoint('shipments/inpost/verify', 'post'),
                send: (data) => this.callCommonEndpoint('shipments/inpost/send', 'post', data)
            },

            furgonetkaAdd: (data) => { return this.callCommonEndpoint('shipments/furgonetka/add-parcel', 'post', data) },
            furgonetkaSend: (shipmentIds) => { return this.callCommonEndpoint('shipments/furgonetka/send', 'post', { shipments: shipmentIds }) },
            remove: (shipmentIds) => { return this.callCommonEndpoint('shipments', 'delete', { shipments: shipmentIds }) },
            checkpriceFurgonetka: (data) => { return this.callCommonEndpoint('shipments/furgonetka/checkprice', 'post', data) },
            searchPointsFurgonetka: (data) => { return this.callCommonEndpoint('shipments/furgonetka/searchPoints', 'post', data) },
            search: (data) => { return this.callCommonEndpoint('shipments/search', 'post', data) },
            searchWithTotal: (data) => { return this.callCommonEndpointWithTotal('shipments/search', 'post', data) },
            generateWaybills: (shipments) => {
                return this.downloadAsBlob('shipments/generate/waybills', 'post', { shipments });
            },
            generateProtocols: (shipments) => {
                return this.downloadAsBlob('shipments/generate/protocols', 'post', { shipments });
            },
            setReciverEmail: (id, email) => { return this.callCommonEndpoint('shipments/' + id, 'put', { receiverEmail: email }) }
        }

        this.applicationForFreeDays = {
            search: (filters) => this.callCommonEndpointWithTotal('application-for-freedays/search', 'post', filters),
            change: (id, data) => { return this.callCommonEndpoint('application-for-freedays/' + id, 'put', data) }
        }

        this.mds = {
            addDeliveryPlan: (data) => this.callCommonEndpoint('mds/delivery-plan', 'post', data),
            editDeliveryPlan: (planId, data) => this.callCommonEndpoint('mds/delivery-plan/' + planId, 'put', data),
            setPlanRealized: (planId, data) => this.callCommonEndpoint('mds/delivery-plan/set-realized/' + planId, 'put', data),
            getDeliveryPlan: (planId) => this.callCommonEndpoint('mds/delivery-plan/' + planId),
            addShipment: (data) => this.callCommonEndpoint('mds/shipments', 'post', data),
            editShipment: (shipId, data) => this.callCommonEndpoint('mds/shipments/' + shipId, 'put', data),
            searchShipmentsWithTotal: (filters) => this.callCommonEndpointWithTotal('mds/shipments/search', 'post', filters),
            searchPlansWithTotal: (filters) => this.callCommonEndpointWithTotal('mds/delivery-plan/search', 'post', filters),
            getDrivers: () => { return this.callCommonEndpoint('mds/drivers/all') },
            addDriver: (data) => this.callCommonEndpoint('mds/drivers', 'post', data),
            editDriver: (driverId, data) => this.callCommonEndpoint('mds/drivers/' + driverId, 'put', data),
            getCurrentLocationForDrivers: (data) => this.callCommonEndpoint('mds/drivers/current-location', 'post', data),
            logs: {
                search: (data) => this.callCommonEndpointWithTotal('mds/driver-logs/search', 'post', data)
            }

        }

        this.system = {
            raports: {
                generateLabel: (key, data) => this.callCommonEndpoint('system/raports/' + key, 'post', data),
                getRaport: (processId) => {
                    let l = this.baseUrl + 'system/raports/' + processId + '?token=' + this.token;
                    return l;
                },
                getStatus: (processId) => this.callCommonEndpoint('system/raports/status/' + processId),
                getAllPosibleRaports: () => this.callCommonEndpoint('system/raports/all-raports', 'get'),
            },
            storage: {
                get: (key, type = 'global') => this.callCommonEndpoint(`system/client_storage/${type}/` + key),
                set: (key, val, type = 'global') => this.callCommonEndpoint(`system/client_storage/${type}/` + key, 'put', { value: val }),
            },
            entites: {
                getGroups: (filters = {}) => this.callCommonEndpointWithTotal('system/entites/groups', 'get', filters),
                get: (filters = {}) => this.callCommonEndpointWithTotal('system/entites', 'get', filters),
                set: (entityId, value) => this.callCommonEndpoint('system/entites/' + entityId, 'put', { value }),
                changeName: (entityId, name) => this.callCommonEndpoint('system/entites/' + entityId, 'put', { name }),
                getOne: (entityId) => this.callCommonEndpoint('system/entites/' + entityId),
                generateHistory: (entityIds, from = null, group = 'day', method = "average") => this.callCommonEndpoint('system/entites/generateEnitiesHistory', 'post', { entityIds, from, group, method }),

                getActions: () => this.callCommonEndpoint('system/entites/actions', 'get'),
                callAction: (actionCode, params) => this.callCommonEndpoint('system/entites/actions/' + actionCode, 'post', params),

                getIntegrations: () => this.callCommonEndpoint('system/entites/integrations', 'get'),
                saveIntegrationConfig: (integrationCode, config) => this.callCommonEndpoint('system/entites/integration/' + integrationCode + '/config', 'put', config),
            },

            data_registers: {
                get: (registerCode) => this.callCommonEndpoint('system/data/' + registerCode, 'get'),
                getAvailable: () => this.callCommonEndpoint('system/data/all', 'get'),
                generateOutput: (regId, data) => this.callCommonEndpoint('system/data/' + regId + '/generate_output_columns_for_params', 'post', data),
                fetchData: (regId, params, pagination, filters = {}) => this.callCommonEndpoint('system/data/' + regId, 'post', { params, pagination, filters }),
                callAction: (regId, actionCode, ctx, input) => this.callCommonEndpoint(`system/data/${regId}/action/${actionCode}`, 'post', { ctx, input })
            },

            history: {
                get: (type, id) => this.callCommonEndpoint(`system/obj_history/${type}/${id}`, 'get'),
                getWithPath: (type, id, path) => this.callCommonEndpoint(`system/obj_history/${type}/${id}/${path}`, 'get')
            },

            eventlogs: {
                get: (filters) => this.callCommonEndpoint(`system/events`, 'get', filters),
            },

            telemetry: {
                event: (eventName, meta = {}) => this.callCommonEndpoint(`system/telemetry`, 'post', { e: eventName, meta, sessionId: this.telemetrySessionId }),

                /**
                 * Zwraca agregację zdarzeń telemetrycznych w czasie, pogrupowaną w przedziały czasowe.
                 * Uzupełnia brakujące przedziały zerami, zapewniając ciągłość szeregu czasowego.
                 * Gdy podano `field`, agreguje wartość liczbową z meta[field] zamiast zliczać zdarzenia.
                 *
                 * @param {Object} filters
                 * @param {string}  [filters.from]       - Data początkowa ISO 8601 (domyślnie: 24h temu)
                 * @param {string}  [filters.to]         - Data końcowa ISO 8601 (domyślnie: teraz + 24h)
                 * @param {string}  [filters.event]      - Filtr po nazwie zdarzenia
                 * @param {string}  [filters.userId]     - Filtr po ID użytkownika
                 * @param {string}  [filters.sessionId]  - Filtr po ID sesji
                 * @param {'hour'|'day'|'minute'} [filters.interval='hour'] - Granulacja przedziałów czasowych
                 * @param {string}  [filters.platform]   - Filtr po platformie aplikacji (app.platform)
                 * @param {string}  [filters.version]    - Filtr po wersji aplikacji (app.version)
                 * @param {string}  [filters.field]      - Pole meta do agregacji, np. "durationMs"
                 * @param {'avg'|'min'|'max'|'p95'|'p99'|'count'} [filters.op='avg'] - Operacja agregacji na meta[field]
                 * @param {number}  [filters.threshold]  - Gdy podano: zlicza zdarzenia gdzie meta[field] > threshold (ignoruje op)
                 * @returns {Promise<{
                 *   from: string,
                 *   to: string,
                 *   interval: string,
                 *   field?: string,
                 *   op?: string,
                 *   data: Array<{ bucket: string, count: number, value?: number }>
                 * }>}
                 */
                aggregate: (filters) => this.callCommonEndpoint(`system/telemetry/aggregate`, 'get', filters),

                /**
                 * Zwraca listę surowych zdarzeń telemetrycznych pasujących do podanych filtrów.
                 * Wyniki są posortowane rosnąco po czasie, limit wynosi 5000 rekordów.
                 *
                 * @param {Object} [filters={}]
                 * @param {string} [filters.from]       - Data początkowa ISO 8601
                 * @param {string} [filters.to]         - Data końcowa ISO 8601
                 * @param {string} [filters.event]      - Filtr po nazwie zdarzenia
                 * @param {string} [filters.userId]     - Filtr po ID użytkownika
                 * @param {string} [filters.sessionId]  - Filtr po ID sesji
                 * @returns {Promise<{ count: number, events: Array<Object> }>}
                 */
                events: (filters = {}) => this.callCommonEndpoint(`system/telemetry/events`, 'get', filters),

                /**
                 * Zwraca posortowaną listę unikalnych nazw zdarzeń telemetrycznych.
                 * Domyślnie ogranicza zakres do ostatnich 30 dni.
                 *
                 * @param {Object} [filters={}]
                 * @param {string} [filters.from]       - Data początkowa ISO 8601 (domyślnie: 30 dni temu)
                 * @param {string} [filters.to]         - Data końcowa ISO 8601
                 * @param {string} [filters.field]      - Pole meta do filtrowania, np. "durationMs"
                 * @param {number} [filters.gt]         - Warunek meta[field] > wartość
                 * @param {number} [filters.gte]        - Warunek meta[field] >= wartość
                 * @param {number} [filters.lt]         - Warunek meta[field] < wartość
                 * @param {number} [filters.lte]        - Warunek meta[field] <= wartość
                 * @param {number} [filters.eq]         - Warunek meta[field] = wartość
                 * @param {string} [filters.userId]     - Filtr po ID użytkownika
                 * @param {string} [filters.sessionId]  - Filtr po ID sesji
                 * @param {string} [filters.platform]   - Filtr po platformie aplikacji
                 * @returns {Promise<{ events: string[] }>}
                 */
                getCodes: (filters = {}) => this.callCommonEndpoint(`system/telemetry/event-codes`, 'get', filters),
            },

            automation: {
                create: (data) => this.callCommonEndpoint(`system/automation/`, 'post', data),
                save: (id, data) => this.callCommonEndpoint(`system/automation/${id}`, 'put', data),
                getOne: (id) => this.callCommonEndpoint(`system/automation/${id}`, 'get'),
                get: (query) => this.callCommonEndpointWithTotal(`system/automation/`, 'get', { q: query }),
                getLastRunsForAutomation: (id) => this.callCommonEndpoint(`system/automation/lastRunsForAutomation/${id}`, 'get'),
                getAvailableElements: () => this.callCommonEndpoint(`system/automation/editor/elements`, 'get'),
            },

            info: () => this.callCommonEndpoint('system/system/info')
        }

        this.systemMessages = {
            remove: (id) => this.callCommonEndpointWithTotal('sysmsg/messages/' + id, 'delete', {}),
            search: (filters) => this.callCommonEndpointWithTotal('sysmsg/messages/search', 'post', filters),
            setSeen: (id, data) => this.callCommonEndpoint('sysmsg/messages/set-seen/' + id, 'post', data),
            getUnseenCount: () => this.callCommonEndpoint('sysmsg/messages/unseen-count/')
        }

        this.chat = {
            getRooms: () => this.callCommonEndpoint('chat/rooms'),
            createRoom: (data) => this.callCommonEndpoint('chat/rooms', 'post', data),
            invite: (roomId, userIds) => this.callCommonEndpoint('chat/rooms/' + roomId + '/members', 'post', { userIds }),
            removeMember: (roomId, userId) => this.callCommonEndpoint('chat/rooms/' + roomId + '/members/' + userId, 'delete'),
            openDm: (userId) => this.callCommonEndpoint('chat/dm', 'post', { userId }),
            getMessages: (roomId, params) => this.callCommonEndpoint('chat/rooms/' + roomId + '/messages', 'get', params),
            sendMessage: (roomId, data) => this.callCommonEndpoint('chat/rooms/' + roomId + '/messages', 'post', data),
            markRead: (roomId) => this.callCommonEndpoint('chat/rooms/' + roomId + '/read', 'post', {})
        }

        this.employeeLogEntry = {
            edit: (id, data) => this.callCommonEndpoint('employee-logs/' + id, 'put', data),
            createForEmployee: (data) => this.callCommonEndpoint('employee-logs/createForEmployee', 'post', data),
            createCorrection: (id, data) => this.callCommonEndpoint('employee-logs/createCorrection/' + id, 'post', data),
            search: (data) => this.callCommonEndpoint('employee-logs/search', 'post', data),
            remove: (id) => this.callCommonEndpoint('employee-logs/removeLogEntry/' + id, 'delete'),
            getMonthlyRaport: (data) => {
                let l = this.baseUrl + 'employee-logs/empMonthlyRaport/?token=' + this.token;
                if (data.empId) l += '&empId=' + data.empId;
                if (typeof data.month != 'undefined') l += '&month=' + data.month;
                if (data.year) l += '&year=' + data.year;
                return l;
            }
        }
        this.productionCard = {
            search: (data) => this.callCommonEndpoint('production/production-card/search', 'post', data)
        }

        this.productionBuffer = {
            get: (productId) => this.callCommonEndpoint('production/production-buffer/' + productId),
            add: (data) => this.callCommonEndpoint('production/production-buffer', 'post', data),
            edit: (id, data) => this.callCommonEndpoint('production/production-buffer/' + id, 'put', data),
            massEdit: (data) => this.callCommonEndpoint('production/production-buffer/mass-edit', 'put', data),
            remove: (id) => this.callCommonEndpoint('production/production-buffer/' + id, 'delete'),
            searchWithTotal: (data) => this.callCommonEndpointWithTotal('production/production-buffer/search', 'post', data)
        }

        this.stock = {
            serie: {
                searchWithTotal: (filters) => this.callCommonEndpointWithTotal('stock/series/search', 'post', filters),
                create: (data) => this.callCommonEndpoint('stock/series/', 'post', data),
                edit: (id, data) => this.callCommonEndpoint('stock/series/' + id, 'put', data),
                remove: (id) => this.callCommonEndpoint('stock/series/' + id, 'delete')
            },
            searchWithTotal: (filters) => this.callCommonEndpointWithTotal('stock/search', 'post', filters),
            searchHistory: (filters) => this.callCommonEndpointWithTotal('stock/history/search', 'post', filters),
            searchStockOrder: (filters) => this.callCommonEndpointWithTotal('stock/order/search', 'post', filters),
            searchDemandProducts: (filters) => this.callCommonEndpointWithTotal('stock/demand/search', 'post', filters),
            searchBulkDemandProducts: (filters) => this.callCommonEndpointWithTotal('stock/demand/search_bulk', 'post', filters),
            addStockOrder: (data) => { return this.callCommonEndpoint('stock/order', 'post', data) },
            getDocument: (id) => { return this.callCommonEndpoint('stock/document/' + id) },
            editDocument: (id, data) => { return this.callCommonEndpoint('stock/document/' + id, 'put', data) },
            removeOrder: (id) => { return this.callCommonEndpoint('stock/order/' + id, "delete") },
            getOrder: (id) => { return this.callCommonEndpoint('stock/order/' + id) },
            removeDemandsByProductId: (data) => { return this.callCommonEndpoint('stock/demand/remove-by-products/', "delete", data) },
            removeDemand: (id) => { return this.callCommonEndpoint('stock/demand/' + id, "delete") },
            closeOrder: (id) => { return this.callCommonEndpoint('stock/order/' + id + '/close', "put") },
            editOrder: (id, data) => { return this.callCommonEndpoint('stock/order/' + id, "put", data) },

            addDemandProduct: (data) => { return this.callCommonEndpoint('stock/demand/', "post", data) },
            saveDemandProduct: (id, data) => { return this.callCommonEndpoint('stock/demand/' + id, "put", data) },

            removeDocument: (id) => { return this.callCommonEndpoint('stock/document/' + id, "delete") },
            search: (data) => { return this.callCommonEndpoint('stock/search', 'post', data) },
            income: (data) => { return this.callCommonEndpoint('stock/income', 'post', data) },
            outcome: (data) => { return this.callCommonEndpoint('stock/outcome', 'post', data) },
            addDocument: (data) => { return this.callCommonEndpoint('stock/document', 'post', data) },
            getStockPosHistory: (itemId) => this.callCommonEndpointWithTotal('stock/history/' + itemId),
            getWherhouses: () => { return this.callCommonEndpoint('stock/warehouse') },

            warehouse: {
                get: (id) => this.callCommonEndpoint('stock/warehouse/' + id),
                getMain: () => this.callCommonEndpoint('stock/warehouse/base'),
                getChildsOf: (parentId) => this.callCommonEndpoint('stock/warehouse/childOf/' + parentId),
                getParents: (id) => this.callCommonEndpoint('stock/warehouse/' + id + '/parents'),
                add: (data) => this.callCommonEndpoint('stock/warehouse', 'post', data),
                save: (id, data) => this.callCommonEndpoint('stock/warehouse/' + id, 'put', data),
                delete: (id) => this.callCommonEndpoint('stock/warehouse/' + id, 'delete'),
                getProducts: (id, filters) => this.callCommonEndpointWithTotal('stock/warehouse/' + id + "/products", 'get', filters),
            },

            searchBox: (data) => { return this.callCommonEndpoint('stock/box/search', 'post', data) },
            addBox: (data) => { return this.callCommonEndpoint('stock/box', 'post', data) },
            getBoxes: () => { return this.callCommonEndpoint('stock/box') },

            analytics: {
                forProduct: (pId, opt) => this.callCommonEndpoint("stock/analytics/forProduct/" + pId, 'get', opt),
                forProductType: (pType, opt) => this.callCommonEndpoint("stock/analytics/forProductType/" + pType, 'get', opt)
            },

            importCSVFile: (file, options) => {
                const form = new FormData();
                form.append('file', file);
                for (const key in options || {}) {
                    form.append(key, options[key]);
                }

                return axios.post(this.baseUrl + 'stock/import', form, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: this.axiosConfig.headers.Authorization
                    }
                }).then((response) => { return response.data; });
            }
        }

        this.semiProductCategory = {
            search: (data) => { return this.callCommonEndpoint('semi-product-category/search', 'post', data) },
            add: (data) => { return this.callCommonEndpoint('semi-product-category', 'post', data) },
            edit: (id, data) => { return this.callCommonEndpoint('semi-product-category/' + id, 'put', data) }
        }

        this.product = {
            searchWithTotal: (filters) => this.callCommonEndpointWithTotal('products/search', 'post', filters),
            search: (data) => { return this.callCommonEndpoint('products/search', 'post', data) },
            searchProductByFeatures: (data) => { return this.callCommonEndpoint('products/searchProductByFeatures', 'post', data) },
            getAvailableCategories: () => { return this.callCommonEndpoint('products/available-categories', 'get') },
            getAlternateUnits: () => { return this.callCommonEndpoint('products/alternate-units', 'get') },
            getProducts: (data) => { return this.callCommonEndpoint('products/search', 'post', data) },
            addProduct: (data) => { return this.callCommonEndpoint('products/', 'post', data) },
            addSemiProductForCategory: (semiCatId, features) => { return this.callCommonEndpoint('products/based-on-template/' + semiCatId, 'post', { features: features }) },
            modifyProduct: (data) => { return this.callCommonEndpoint('products/' + data._id, 'put', data) },
            save: (prodId, data) => this.callCommonEndpoint('products/' + prodId, 'put', data),
            massEdit: (data) => { return this.callCommonEndpoint('products/mass-edit', 'put', data) },
            getProduct: (id) => { return this.callCommonEndpoint('products/' + id) },
            getSimilarProducts: (id) => { return this.callCommonEndpoint('products/' + id + '/similarProducts') },
            setFeature: (id, fId, value, method) => { return this.callCommonEndpoint('products/' + id + '/feature/' + fId, method, { value: value }) },
            getSemiProduct: (id) => {
                return new Promise((resolve, reject) => {
                    const d = { _id: 1, name: 'Ramka 100/100', typ: 'ramki', stanowisko: 'Nazwa stanowiska', wh: '100/100', other: [], qty: 10, w: 100, h: 100 };
                    resolve(d);
                });
            },
            searchProductsFeatures: (data) => { return this.callCommonEndpointWithTotal('product-feature-types/search', 'post', data) },
            getProductsFeatures: () => { return this.callCommonEndpoint('product-feature-types/search', 'post', {}) },
            addProductsFeature: (feature) => { return this.callCommonEndpoint('product-feature-types', 'post', feature) },
            editProductsFeature: (feature) => { return this.callCommonEndpoint('product-feature-types/' + feature._id, 'put', feature) },
            deleteProductsFeature: (code) => { return this.callCommonEndpoint('product-feature-types/' + code, 'delete') },
            getSemiProductDef: () => { return this.callCommonEndpoint('products/semi/def/search', 'post', {}) },
            modifySemiProductDef: (data) => { return this.callCommonEndpoint('products/semi/def/' + data._id, 'put', data) },
            addNewSemiProductDef: (data) => { return this.callCommonEndpoint('products/semi/def/', 'post', data) },
            getStock: (id) => { return this.callCommonEndpoint('stock/' + id) },
            modifyStock: (data) => { return this.callCommonEndpoint('stock/', 'post', data) },

            types: {
                get: (code) => this.callCommonEndpoint('products/v3/product-types/' + code, 'get'),
                getAll: () => this.callCommonEndpoint('products/v3/product-types', 'get', {}),
                search: (where) => this.callCommonEndpointWithTotal('products/v3/product-types/search', 'post', where || {}),
                create: (data) => this.callCommonEndpoint('products/v3/product-types', 'post', data),
                save: (code, data) => this.callCommonEndpoint('products/v3/product-types/' + code, 'put', data),
                delete: (code) => this.callCommonEndpoint('products/v3/product-types/' + code, 'delete'),
                getAvailableEWICategories: () => { return this.callCommonEndpoint('products/v3/product-types/available-ewi-categories', 'get') }
            }
        }

        this.settings = {
            getPrintUrls: () => { return this.callCommonEndpoint('production/print/configuration') },
            setPrintUrls: (data) => { return this.callCommonEndpoint('production/print/configuration', 'post', data) }
        }

        this.production = {

            searchMaterials: (data) => { return this.callCommonEndpoint('materials/search', 'post', data) },
            addMaterials: (data) => { return this.callCommonEndpoint('materials', 'post', data) },
            editMaterials: (id, data) => { return this.callCommonEndpoint('materials/' + id, 'put', data) },
            searchWorkplaces: () => { return this.callCommonEndpoint('production/workplaces/search', 'post', {}) },
            searchDailyWorkLogs: (data) => { return this.callCommonEndpoint('production/worklogs/search', 'post', data) },
            addWorkplace: (data) => { return this.callCommonEndpoint('production/workplaces', 'post', data) },
            editWorkplace: (data) => { return this.callCommonEndpoint('production/workplaces/' + data._id, 'put', data) },
            getWorkplace: (id) => { return this.callCommonEndpoint('production/workplaces/' + id) },
            getWorkplacesProductionSatisfyRaport: () => { return this.callCommonEndpoint('production/workplaces/production-satisfy-raport') },

            searchRecipes: (data) => { return this.callCommonEndpoint('production/recipes/search', 'post', data) },
            searchRecipesByConditions: (data) => { return this.callCommonEndpoint('production/recipes/searchByConditions', 'post', data) },
            searchRecipesByConditionsV2: (data) => { return this.callCommonEndpoint('production/recipes_v2/searchByConditions', 'post', data) },
            addRecipes: (data) => { return this.callCommonEndpoint('production/recipes', 'post', data) },
            duplicateRecipe: (id) => { return this.callCommonEndpoint('production/recipes/' + id + '/copy', 'post', {}) },
            editRecipe: (data) => { return this.callCommonEndpoint('production/recipes/' + data._id, 'put', data) },
            getRecipe: (id) => { return this.callCommonEndpoint('production/recipes/' + id) },
            simulateRecipe: (recipeId, data) => { return this.callCommonEndpoint('production/recipes/' + recipeId + '/simulate', 'post', data) },

            searchRecipesV2: (data) => { return this.callCommonEndpoint('production/recipes_v2/search', 'post', data) },
            getRecipeV2: (id) => { return this.callCommonEndpoint('production/recipes_v2/' + id) },
            addRecipesV2: (data) => { return this.callCommonEndpoint('production/recipes_v2', 'post', data) },
            editRecipeV2: (data) => { return this.callCommonEndpoint('production/recipes_v2/' + data._id, 'put', data) },
            simulateRecipeV2: (recipeId, data) => { return this.callCommonEndpoint('production/recipes_v2/' + recipeId + '/simulate', 'post', data) },

            getSharedFunctions: () => { return this.callCommonEndpoint('production/recipes/sharedFunctions') },
            saveSharedFunctions: (content) => { return this.callCommonEndpoint('production/recipes/sharedFunctions', 'post', { content }) },

            addFreeDays: (data) => { return this.callCommonEndpoint('production/freedays/range', 'post', data) },
            getFreeDays: (data) => { return this.callCommonEndpoint('production/freedays/search', 'post', data) },
            getFreeDaysWithTotal: (data) => this.callCommonEndpointWithTotal('production/freedays/search', 'post', data),
            removeFreeDay: (freeDayId) => { return this.callCommonEndpoint('production/freedays/' + freeDayId, 'put', { isRemoved: true }) }, //zeby nie uswac strego sposobu do uswania PUTem to do daty dodałam isRemove
            editFreeDay: (freeDayId, data) => { return this.callCommonEndpoint('production/freedays/' + freeDayId, 'put', data) },

            setEmpToWorkPlace: (workplaceId, empId, eff) => { return this.callCommonEndpoint('production/workplaces/' + workplaceId + '/employee/' + empId, 'put', { efficiency: eff }) },
            deleteEmpFromWorkPlace: (workplaceId, empId) => { return this.callCommonEndpoint('production/workplaces/' + workplaceId + '/employee/' + empId, 'delete') },

            summary: {
                getCurrenlyInProduction: () => this.callCommonEndpoint('production/summary/currenlyInProduction', 'get'),
                getDailyProductionRateFor: (pTypeCode) => this.callCommonEndpoint('production/summary/dailyProductionRateFor/' + pTypeCode, 'get')
            },

            queue: {
                get: () => { return this.callCommonEndpoint('production/production-queue/') },
                move: (prId, newIdx) => { return this.callCommonEndpoint('production/production-queue/move', 'post', { prId: prId, toIdx: newIdx }) }
            },

            schedule: {
                getForWorkplace: (workplaceId) => { return this.callCommonEndpoint('production/production-schedule/atWorkplace/' + workplaceId) },
                getCofiguration: () => { return this.callCommonEndpoint('production/production-schedule/configuration/') },
                setConfiguration: (data) => { return this.callCommonEndpoint('production/production-schedule/configuration/', 'post', data) }
            },

            request: {
                complete: (zpId) => { return this.callCommonEndpoint('production/production-request/' + zpId + '/complete', 'post', {}) },

                estimateProductionTime: (data) => { return this.callCommonEndpoint('production/v3/production-request/estimate-production-time', 'post', data) },

                create: (data) => { return this.callCommonEndpoint('production/production-request/', 'post', data) },
                update: (idReq, data) => { return this.callCommonEndpoint('production/production-request/' + idReq, 'put', data) },
                search: (data) => { return this.callCommonEndpoint('production/production-request/search', 'post', data) },
                removePart: (prId, partId) => { return this.callCommonEndpoint('production/production-request/' + prId + '/remove-parts', 'put', { partId: partId }) },
                get: (id) => { return this.callCommonEndpoint('production/production-request/' + id) },
                getTags: () => { return this.callCommonEndpoint('production/v3/production-request/availableTags') },
                delete: (id) => { return this.callCommonEndpoint('production/production-request/' + id, 'delete') },
                searchWithCount: (filters) => {
                    return axios({
                        method: 'post',
                        url: this.baseUrl + 'production/production-request/search',
                        headers: this.axiosConfig.headers,
                        data: JSON.stringify(filters)
                    }).then((response) => {
                        const arrayRes = {};
                        arrayRes.data = response.data;
                        arrayRes.total = parseInt(response.headers['x-total-found']);
                        return arrayRes;
                    });
                },
                moveAll: (daysCount) => { return this.callCommonEndpoint('production/production-request/move-all-deadlines', 'post', { daysCount: daysCount }) },

                v3: {
                    searchAvailable: (data) => { return this.callCommonEndpoint('production/v3/production-request/search-available', 'post', data) },
                    forceProduction: (id) => { return this.callCommonEndpoint('production/v3/production-request/' + id + '/force-production', 'post', {}) },
                    addIngredientForPr: (id, data) => { return this.callCommonEndpoint('production/v3/production-request/' + id + '/add-ingredient', 'post', data) },
                    removeIngredientForPr: (id, data) => { return this.callCommonEndpoint('production/v3/production-request/' + id + '/remove-ingredient', 'post', data) },
                    searchGrupsPrByOrders: (data) => { return this.callCommonEndpoint('production/v3/production-request/search-groups', 'post', data) },
                    changeDedlineForPrsGrup: (prsIds, deadline) => { return this.callCommonEndpoint('production/v3/production-request/batch/change_deadline', 'post', { _ids: prsIds, deadline: deadline }) },
                    changeDedlineForPrsGrupByOrderId: (orderId, deadline) => { return this.callCommonEndpoint('production/v3/production-request/batch/change_deadline_by_order_id', 'post', { orderId: orderId, deadline: deadline }) },
                    get: (id) => this.callCommonEndpoint('production/v3/production-request/' + id),
                    remove: (id) => this.callCommonEndpoint('production/v3/production-request/' + id, 'delete', {}),
                    getGrupForOrder: (id) => this.callCommonEndpointWithTotal('production/v3/production-request/get-grup-by-order/' + id),
                    search: (data) => this.callCommonEndpointWithTotal('production/v3/production-request/search', 'post', data),
                    create: (data) => { return this.callCommonEndpoint('production/v3/production-request/batch', 'post', data) },
                    notifyCustomer: (data) => { return this.callCommonEndpoint('production/v3/production-request/notify-customer', 'post', data) },
                    createOne: (data) => { return this.callCommonEndpoint('production/v3/production-request/', 'post', data) },
                    completePR: (prId, data = { leftProductsAt: {} }) => this.callCommonEndpoint(`production/v3/production-request/${prId}/complete`, 'post', data),
                    adjustProductionDateToShipDate: (orderId, shipDate) => this.callCommonEndpoint(`production/v3/production-request/adjust-production-date-to-ship-date`, 'post', { orderId, shipDate }),
                    moveAll: (daysCount) => { return this.callCommonEndpoint('production/v3/production-request/move-all-deadlines', 'post', { daysCount: daysCount }) },

                    runLive: (prsIds) => this.callCommonEndpoint('production/v3/production-request/batch/go_live', 'post', { _ids: prsIds }),
                    runLiveByIntentIds: (intentIds) => this.callCommonEndpoint('production/v3/production-request/batch/go_live_by_intent_ids', 'post', { _ids: intentIds })
                }
            },

            recipes: {
                searchByProducts: (data) => { return this.callCommonEndpoint('production/recipes/searchByProducts', 'post', data) },

                v3: {
                    search: (filters) => this.callCommonEndpointWithTotal('production/recipes_v3/search', 'post', filters),
                    get: (id) => this.callCommonEndpoint('production/recipes_v3/' + id),
                    create: (data) => this.callCommonEndpoint('production/recipes_v3/', 'post', data),
                    save: (id, data) => this.callCommonEndpoint('production/recipes_v3/' + id, 'put', data),
                    remove: (id) => this.callCommonEndpoint('production/recipes_v3/' + id, 'delete'),
                    simulate: (recipeId, data) => this.callCommonEndpoint(`production/recipes_v3/${recipeId}/simulate`, 'post', data),
                    simulateProduct: (productId, qty) => this.callCommonEndpoint(`production/recipes_v3/simulateProduct`, 'post', { productId, qty })
                },

                graphNodes: {
                    search: (filters) => this.callCommonEndpointWithTotal('production/graph_nodes/search', 'post', filters),
                    create: (data) => this.callCommonEndpointWithTotal('production/graph_nodes/', 'post', data),
                    update: (id, data) => this.callCommonEndpointWithTotal('production/graph_nodes/' + id, 'put', data),
                    remove: (id) => this.callCommonEndpointWithTotal('production/graph_nodes/' + id, 'delete', {})
                }
            },

            manualIngredients: {
                get: (productId) => this.callCommonEndpoint('production/manual-ingredients/' + productId),
                enable: (productId) => this.callCommonEndpoint(`production/manual-ingredients/${productId}/enable`, 'post', {}),
                disable: (productId) => this.callCommonEndpoint(`production/manual-ingredients/${productId}/disable`, 'post', {}),
                update: (productId, data) => this.callCommonEndpoint(`production/manual-ingredients/${productId}`, 'put', data)
            },

            cnotes: {
                search: (where) => { return this.callCommonEndpoint('production/construction-notes/search', 'post', where) },
                create: (data) => { return this.callCommonEndpoint('production/construction-notes', 'post', data) },
                update: (id, data) => { return this.callCommonEndpoint('production/construction-notes/' + id, 'put', data) },
                remove: (id) => { return this.callCommonEndpoint('production/construction-notes/' + id, 'delete', {}) }
            },

            materials: {
                searchProductionProductMinQty: (filters) => this.callCommonEndpointWithTotal('production/minimum-production-qty/search', 'post', filters),
                createProductionMinQty: (data) => { return this.callCommonEndpoint('production/minimum-production-qty', 'post', data) },
                massEdit: (data) => this.callCommonEndpoint('production/minimum-production-qty/mass-edit', 'put', data),
                updateProductionMinQty: (id, data) => { return this.callCommonEndpoint('production/minimum-production-qty/' + id, 'put', data) },
                removeProductionMinQty: (id) => { return this.callCommonEndpoint('production/minimum-production-qty/' + id, 'delete', {}) }
            },

            materialUsage: {
                getForProduct: (productId) => this.callCommonEndpoint('production/material-usage/forProduct/' + productId),
            }
        }

        this.worklogs = {
            v2: {
                search: (data) => { return this.callCommonEndpoint('production/v2/worklogs/search', 'post', data) },
                searchWithTotal: (data) => { return this.callCommonEndpointWithTotal('production/v2/worklogs/search', 'post', data) },
                save: (id, data) => { return this.callCommonEndpoint('production/v2/worklogs/' + id, 'put', data) },
                createLog: (data) => { return this.callCommonEndpoint('production/v2/worklogs/create-worklog', 'post', data) },
                createDayLog: (data) => { return this.callCommonEndpoint('production/v2/worklogs/create-day-worklog', 'post', data) }
            }
        }

        this.tasks = {
            v2: {
                search: (filters) => this.callCommonEndpointWithTotal('production/v2/tasks/search', 'post', filters),
                forceRun: (taskId) => { return this.callCommonEndpoint('production/v2/tasks/' + taskId + '/force-run', 'post', {}) },
                manualyEnd: (taskId) => { return this.callCommonEndpoint('production/v2/tasks/' + taskId + '/manualy-end', 'post', {}) }
            },

            definitions: {
                search: (filters) => this.callCommonEndpointWithTotal('production/task-defs/search', 'post', filters)
            },

            addDef: (data) => { return this.callCommonEndpoint('production/task-defs', 'post', data) },
            getPackingTaskDefs: () => { return this.callCommonEndpoint('production/task-defs/search', 'post', { isPacking: true }) },
            searchDef: (query) => { return this.callCommonEndpoint('production/task-defs/search', 'post', { query: query }) },
            modifyDef: (data) => { return this.callCommonEndpoint('production/task-defs/' + data._id, 'put', data) },
            createbasedOnRecipeBatch: (data) => { return this.callCommonEndpoint('production/tasks/basedOnRecipeBatch ', 'post', data) },
            createbasedOnRecipe: (data) => { return this.callCommonEndpoint('production/tasks/basedOnRecipe ', 'post', data) },
            complete: (ids) => { return this.callCommonEndpoint('production/tasks/complete ', 'post', { tasks: ids }) },
            changeStatus: (ids, status) => { return this.callCommonEndpoint('production/tasks/changeStatus ', 'post', { tasks: ids, status }) },
            searchTasks: (data) => { return this.callCommonEndpoint('production/tasks/search', 'post', data) },
            searchWithCount: (data) => {
                return axios({
                    method: 'post',
                    url: this.baseUrl + 'production/tasks/search',
                    headers: this.axiosConfig.headers,
                    data: JSON.stringify(data)
                }).then((response) => {
                    return {
                        data: response.data,
                        total: parseInt(response.headers['x-total-found'])
                    };
                });
            },
            create: (data) => { return this.callCommonEndpoint('production/tasks/', 'post', data) },
            edit: (taskId, data) => { return this.callCommonEndpoint('production/tasks/' + taskId, 'put', data) },
            massConfirm: () => { return this.callCommonEndpoint('production/tasks/mass-confirm', 'post', {}) }
        }

        // --- MACHINES & SERVICE TASKS ---
        // Dokumentacja w pliku API_MACHINES.md
        this.machines = {
            create: (data) => this.callCommonEndpoint('production/machines/create', 'post', data),
            update: (id, data) => this.callCommonEndpoint(`production/machines/${id}`, 'put', data),
            search: (filters) => this.callCommonEndpoint('production/machines/search', 'post', filters || {}),
            getAvailableGroups: () => this.callCommonEndpoint('production/machines/available-groups', 'get'),
            get: (id) => this.callCommonEndpoint('production/machines/' + id, 'get'),
            usageDeclarations: {
                getToday: () => this.callCommonEndpoint('production/machines/todayUsageDeclarations', 'get'),
                search: (filters) => this.callCommonEndpoint('production/machines/usage-declarations/search', 'post', filters || {})
            },
            serviceDefinitions: {
                create: (machineId, data) => this.callCommonEndpoint(`production/machines/${machineId}/service-definitions/create`, 'post', data),
                update: (machineId, defId, data) => this.callCommonEndpoint(`production/machines/${machineId}/service-definitions/${defId}/update`, 'post', data),
                delete: (machineId, defId) => this.callCommonEndpoint(`production/machines/${machineId}/service-definitions/${defId}`, 'delete')
            },
            serviceTasks: {
                create: (machineId, definitionId, scheduledFor) => this.callCommonEndpoint(`production/machines/service-tasks`, 'post', { machineId, definitionId, scheduledFor }),
                search: (filters) => this.callCommonEndpoint('production/machines/service-tasks/search', 'post', filters),
                get: (filters, limit = 100, page = 1) => this.callCommonEndpoint('production/machines/service-tasks', 'get', { ...filters, limit, page }),
                delete: (taskId) => this.callCommonEndpoint(`production/machines/service-tasks/${taskId}`, 'delete'),
                estimate: (fromDay, toDay, machineId = null, maintanceBy = null, skipDaily = false) => this.callCommonEndpoint('production/machines/service-tasks/estimate', 'post', { fromDay, toDay, machineId, maintanceBy, skipDaily }),
                reschedule: (taskId, newDate) => this.callCommonEndpoint(`production/machines/service-tasks/${taskId}/reschedule`, 'post', { newDate }),
                upcomingForEmployee: (employeeId, daysAhead) => this.callCommonEndpoint('production/machines/service-tasks/upcoming-for-employee', 'post', { employeeId, daysAhead }),
                completeByEmployee: (taskId, data) => this.callCommonEndpoint(`production/machines/service-tasks/${taskId}/complete`, 'post', data),
                completeByUser: (taskId, data) => this.callCommonEndpoint(`production/machines/service-tasks/${taskId}/complete-by-user`, 'post', data || {})
            }
        }

        this.iso = {
            tools: {
                get: (filters) => this.callCommonEndpoint('production/iso/measurement_tools', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/measurement_tools/${id}`, 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/measurement_tools', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/measurement_tools/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/measurement_tools/${id}`, 'delete')
            },

            suppliers: {
                getRanking: (from, to) => this.callCommonEndpoint('production/iso/suppliers/rating', 'get', { from, to }),
                evaluations: {
                    /**
                     * Pobiera oceny dostawców z możliwością filtrowania po dacie, dostawcy i zamówieniu.
                     * @param {Object} filters { from, to, supplierId, orderId, limit, page }
                     * @returns {Promise} { items: [], total: number }
                     */
                    get: (filters) => this.callCommonEndpoint('production/iso/suppliers/evaluations', 'get', filters || {}),
                    getExistingCategories: () => this.callCommonEndpoint('production/iso/suppliers/evaluation-categories', 'get'),
                    getById: (id) => this.callCommonEndpoint(`production/iso/suppliers/evaluations/${id}`, 'get'),
                    create: (data) => this.callCommonEndpoint('production/iso/suppliers/evaluations', 'post', data),
                    update: (id, data) => this.callCommonEndpoint(`production/iso/suppliers/evaluations/${id}`, 'put', data),
                    delete: (id) => this.callCommonEndpoint(`production/iso/suppliers/evaluations/${id}`, 'delete')
                },
                qualifications: {
                    /**
                     * Pobiera kwalifikacje dostawców z możliwością filtrowania po dostawcy, roku i kwartale.
                     * @param {Object} filters - Możliwe filtry: supplierId, year, quarter, limit, page
                     * @return {Promise} { items: [], total: number }
                     */
                    get: (filters) => this.callCommonEndpoint('production/iso/suppliers/qualifications', 'get', filters || {}),
                    getById: (id) => this.callCommonEndpoint(`production/iso/suppliers/qualifications/${id}`, 'get'),
                    create: (data) => this.callCommonEndpoint('production/iso/suppliers/qualifications', 'post', data),
                    update: (id, data) => this.callCommonEndpoint(`production/iso/suppliers/qualifications/${id}`, 'put', data),
                    delete: (id) => this.callCommonEndpoint(`production/iso/suppliers/qualifications/${id}`, 'delete')
                }
            },

            couriers: {
                getServiceCodes: () => this.callCommonEndpoint('production/iso/couriers/service-codes', 'get'),
                get: (filters) => this.callCommonEndpoint('production/iso/couriers', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/couriers/${id}`, 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/couriers', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/couriers/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/couriers/${id}`, 'delete'),
                getRanking: (from, to) => this.callCommonEndpoint('production/iso/couriers/rating', 'get', { from, to }),
                evaluations: {
                    get: (filters) => {
                        return this.callCommonEndpoint('production/iso/couriers/evaluations', 'get', filters || {});
                    },
                    getById: (id) => this.callCommonEndpoint(`production/iso/couriers/evaluations/${id}`, 'get'),
                    create: (data) => this.callCommonEndpoint('production/iso/couriers/evaluations', 'post', data),
                    update: (id, data) => this.callCommonEndpoint(`production/iso/couriers/evaluations/${id}`, 'put', data),
                    delete: (id) => this.callCommonEndpoint(`production/iso/couriers/evaluations/${id}`, 'delete')
                }
            },

            labTestDefinitions: {
                get: (filters) => this.callCommonEndpoint('production/iso/lab_test_definitions', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/lab_test_definitions/${id}`, 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/lab_test_definitions', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/lab_test_definitions/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/lab_test_definitions/${id}`, 'delete')
            },

            labTestRaports: {
                get: (filters) => this.callCommonEndpoint('production/iso/lab_test_raports', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/lab_test_raports/${id}`, 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/lab_test_raports', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/lab_test_raports/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/lab_test_raports/${id}`, 'delete')
            },

            trainingDefinitions: {
                get: (filters) => this.callCommonEndpoint('production/iso/training_definitions', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/training_definitions/${id}`, 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/training_definitions', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/training_definitions/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/training_definitions/${id}`, 'delete')
            },

            trainings: {
                get: (filters) => this.callCommonEndpoint('production/iso/trainings', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/trainings/${id}`, 'get'),
                byPerson: (personId, filters) => this.callCommonEndpoint(`production/iso/trainings/by-person/${personId}`, 'get', filters || {}),
                upcomingExpirations: (days) => this.callCommonEndpoint('production/iso/trainings/upcoming-expirations', 'get', { days }),
                create: (data) => this.callCommonEndpoint('production/iso/trainings', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/trainings/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/trainings/${id}`, 'delete'),
                raportPlanUrl: (year) => `${this.baseUrl}production/iso/trainings/raport/plan?year=${year}&token=${this.token}`,
                raportCompletedUrl: (year) => `${this.baseUrl}production/iso/trainings/raport/completed?year=${year}&token=${this.token}`
            },

            medicalExams: {
                get: (filters) => this.callCommonEndpoint('production/iso/medical_exams', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/medical_exams/${id}`, 'get'),
                byPerson: (personId, filters) => this.callCommonEndpoint(`production/iso/medical_exams/by-person/${personId}`, 'get', filters || {}),
                upcomingExpirations: (days) => this.callCommonEndpoint('production/iso/medical_exams/upcoming-expirations', 'get', { days }),
                create: (data) => this.callCommonEndpoint('production/iso/medical_exams', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/medical_exams/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/medical_exams/${id}`, 'delete')
            },

            qualifications: {
                get: (filters) => this.callCommonEndpoint('production/iso/qualifications', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/qualifications/${id}`, 'get'),
                byPerson: (personId, filters) => this.callCommonEndpoint(`production/iso/qualifications/by-person/${personId}`, 'get', filters || {}),
                upcomingExpirations: (days) => this.callCommonEndpoint('production/iso/qualifications/upcoming-expirations', 'get', { days }),
                create: (data) => this.callCommonEndpoint('production/iso/qualifications', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/qualifications/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/qualifications/${id}`, 'delete')
            },

            complaints: {
                get: (filters) => this.callCommonEndpoint('production/iso/complaints', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/complaints/${id}`, 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/complaints', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/complaints/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/complaints/${id}`, 'delete')
            },

            nonConformingProducts: {
                get: (filters) => this.callCommonEndpoint('production/iso/non-conforming-products', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/non-conforming-products/${id}`, 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/non-conforming-products', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/non-conforming-products/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/non-conforming-products/${id}`, 'delete'),
                managerReview: (id, data) => this.callCommonEndpoint(`production/iso/non-conforming-products/${id}/manager-review`, 'post', data),
                boardReview: (id, data) => this.callCommonEndpoint(`production/iso/non-conforming-products/${id}/board-review`, 'post', data),
                addDisposition: (id, data) => this.callCommonEndpoint(`production/iso/non-conforming-products/${id}/dispositions`, 'post', data),
                cancelDisposition: (id, dispositionId, data) => this.callCommonEndpoint(`production/iso/non-conforming-products/${id}/dispositions/${dispositionId}/cancel`, 'post', data)
            },

            riskAssessments: {
                get: (filters) => this.callCommonEndpoint('production/iso/risk-assessments', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/risk-assessments/${id}`, 'get'),
                byPerson: (personId) => this.callCommonEndpoint(`production/iso/risk-assessments/by-person/${personId}`, 'get'),
                pendingAcknowledgements: () => this.callCommonEndpoint('production/iso/risk-assessments/pending-acknowledgements', 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/risk-assessments', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/risk-assessments/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/risk-assessments/${id}`, 'delete'),
                addParticipant: (id, data) => this.callCommonEndpoint(`production/iso/risk-assessments/${id}/participants`, 'post', data),
                removeParticipant: (id, personId) => this.callCommonEndpoint(`production/iso/risk-assessments/${id}/participants/${personId}`, 'delete'),
                acknowledgeParticipant: (id, personId, data) => this.callCommonEndpoint(`production/iso/risk-assessments/${id}/participants/${personId}/acknowledge`, 'put', data),
                revokeParticipant: (id, personId) => this.callCommonEndpoint(`production/iso/risk-assessments/${id}/participants/${personId}/revoke`, 'put')
            },

            materialCertificates: {
                get: (filters) => this.callCommonEndpoint('production/iso/material_certificates', 'get', filters || {}),
                getById: (id) => this.callCommonEndpoint(`production/iso/material_certificates/${id}`, 'get'),
                create: (data) => this.callCommonEndpoint('production/iso/material_certificates', 'post', data),
                update: (id, data) => this.callCommonEndpoint(`production/iso/material_certificates/${id}`, 'put', data),
                delete: (id) => this.callCommonEndpoint(`production/iso/material_certificates/${id}`, 'delete'),
                attachSerie: (id, serieId) => this.callCommonEndpoint(`production/iso/material_certificates/${id}/attach/${serieId}`, 'put'),
                detachSerie: (id, serieId) => this.callCommonEndpoint(`production/iso/material_certificates/${id}/detach/${serieId}`, 'put')
            }
        }
    }

    setToken(token) {
        this.token = token;
        this.axiosConfig.headers.Authorization = 'Bearer ' + token;
        this.telemetrySessionId = 'session-' + Math.random().toString(36).substring(2);
    }

    callCommonEndpoint(endpoint, method, data) {
        if (!method) method = 'get';
        return axios({
            method: method,
            url: this.baseUrl + endpoint,
            headers: this.axiosConfig.headers,
            data: JSON.stringify(data),
            params: method == 'get' ? data : undefined
        }).then((response) => { return response.data; });
    }

    /**
     * POST z odpowiedzią text/event-stream (SSE). Axios nie streamuje w przeglądarce,
     * więc używamy fetch + ReadableStream. Zwraca Promise kończący się wraz ze strumieniem.
     */
    async streamSSE(endpoint, body, onEvent) {
        const response = await fetch(this.baseUrl + endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: this.axiosConfig.headers.Authorization
            },
            body: JSON.stringify(body)
        });

        const contentType = response.headers.get('content-type') || '';
        if (!response.ok || !contentType.includes('text/event-stream')) {
            let errorMessage = 'Błąd ' + response.status;
            try {
                const data = await response.json();
                if (data && data.error) errorMessage = data.error;
            } catch (e) { /* odpowiedź bez JSON */ }
            throw new Error(errorMessage);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        for (;;) {
            const { done, value } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, { stream: true });

            let sepIndex;
            while ((sepIndex = buffer.indexOf('\n\n')) !== -1) {
                const rawEvent = buffer.slice(0, sepIndex);
                buffer = buffer.slice(sepIndex + 2);

                let eventName = 'message';
                const dataLines = [];
                for (const line of rawEvent.split('\n')) {
                    if (line.startsWith('event:')) eventName = line.slice(6).trim();
                    else if (line.startsWith('data:')) dataLines.push(line.slice(5).trimStart());
                }
                if (dataLines.length === 0) continue;

                let data;
                try {
                    data = JSON.parse(dataLines.join('\n'));
                } catch (e) {
                    data = dataLines.join('\n');
                }
                onEvent(eventName, data);
            }
        }
    }

    callCommonEndpointWithTotal(endpoint, method, data) {
        if (!method) method = 'get';
        return axios({
            method: method,
            url: this.baseUrl + endpoint,
            headers: this.axiosConfig.headers,
            data: JSON.stringify(data),
            params: method == 'get' ? data : undefined
        }).then((response) => {
            return {
                data: response.data,
                total: parseInt(response.headers['x-total-found']) || 0
            }
        });
    }

    downloadAsBlob(endpoint, method, data) {
        if (!method) method = 'get';
        return axios({
            method: method,
            url: this.baseUrl + endpoint,
            headers: this.axiosConfig.headers,
            responseType: 'arraybuffer',
            data: JSON.stringify(data)
        }).then(r => {
            const file = new Blob([r.data], {
                type: r.headers['content-type'] ? r.headers['content-type'] : 'application/zip'
            });
            return file;
        }).catch(e => {
            if (!e.response || !e.response.data) throw e;
            const enc = new TextDecoder("utf-8");
            const errorDecoded = JSON.parse(enc.decode(e.response.data));
            throw errorDecoded;
        });
    }
}

const instance = new Api();

export default instance;
